import type { RouterConfig } from '@nuxt/schema';

export default <RouterConfig>{
  routes: _routes => {
    return [
      ..._routes,
      {
        name: 'subject',
        path: '/subject/:type/:page',
        component: () => import('~/pages/subject/index.vue'),
        meta: {
          layout: 'sidebar',
        },
      },
      {
        name: 'questionsno-id',
        path: '/questionsno/:id/:content?',
        component: () => import('~/pages/questionsno/index.vue'),
        meta: {
          layout: 'sidebar',
        },
      },
      {
        name: 'questions-id',
        path: '/questions-:id/:content?',
        component: () => import('~/pages/questions/index.vue'),
        meta: {
          layout: 'sidebar',
        },
      },
      {
        name: 'questions',
        path: '/questions/:id/:content?',
        component: () => import('~/pages/questions/index.vue'),
        meta: {
          layout: 'sidebar',
        },
      },
      {
        name: 'subjects',
        path: '/subjects',
        component: () => import('~/pages/subjects/index.vue'),
        meta: {
          layout: 'blog',
        },
      },
      {
        name: 'calculator',
        path: '/calculator',
        component: () => import('~/pages/calculator/index.vue'),
        meta: {
          layout: 'sidebar',
        },
      },
      {
        name: 'essays',
        path: '/essays/:type/:page',
        component: () => import('~/pages/essays/index.vue'),
        meta: {
          layout: 'sidebar',
        },
      },
      {
        name: 'essays-detail',
        path: '/essays-:id/:page',
        component: () => import('~/pages/essaysDetail/index.vue'),
        meta: {
          layout: 'sidebar',
        },
      },
      {
        name: 'sitemap',
        path: '/sitemap-:page',
        component: () => import('~/pages/sitemap/index.vue'),
        meta: {
          layout: 'empty',
        },
      },
      {
        name: 'essaysitemap',
        path: '/essaysitemap-:page',
        component: () => import('~/pages/essaysitemap/index.vue'),
        meta: {
          layout: 'empty',
        },
      },
      {
        name: 'booksummarySitemap',
        path: '/booksummarysitemap-:page',
        component: () => import('~/pages/booksummarySitemap/index.vue'),
        meta: {
          layout: 'empty',
        },
      },
      {
        name: 'textbooksolutionSitemap',
        path: '/textbooksolutionsitemap-:page',
        component: () => import('~/pages/textbooksolutionSitemap/index.vue'),
        meta: {
          layout: 'empty',
        },
      },
      {
        name: 'knowledgeSitemap',
        path: '/knowledgesitemap-:page',
        component: () => import('~/pages/knowledgesitemap/index.vue'),
        meta: {
          layout: 'empty',
        },
      },
      {
        name: 'knowledge-detail',
        path: '/knowledge/:kid-:kname',
        component: () => import('~/pages/knowledge/details/index.vue'),
        meta: {
          layout: 'sidebar',
        },
      },
      // {
      //   name: 'knowledge-list',
      //   path: '/knowledge/list/:alpha-:page',
      //   component: () => import('~/pages/knowledge/list/index.vue'),
      //   meta: {
      //     layout: 'sidebar',
      //   },
      // },
      {
        name: 'knowledge-subject',
        path: '/knowledge/:subject/:alpha-:page',
        component: () => import('~/pages/knowledge/list/index.vue'),
        meta: {
          layout: 'sidebar',
        },
      },
      {
        name: '404',
        path: '/404',
        component: () => import('~/error.vue'),
        meta: {
          layout: 'empty',
        },
      },
      {
        path: '/textbooksolution/:page(\\d+)?',
        name: 'textbook-list-all',
        component: () => import('~/pages/textbook-list/explorer/index.vue'),
        meta: {
          layout: 'sidebar',
        },
      },
      {
        path: '/textbooksolution/:subject/:page?',
        name: 'textbook-list',
        component: () => import('~/pages/textbook-list/explorer/index.vue'),
        meta: {
          layout: 'sidebar',
        },
      },
      {
        name: 'textbook-search',
        path: '/tbs',
        component: () => import('~/pages/textbook-list/search/index.vue'),
        meta: {
          layout: 'sidebar',
        },
      },
      {
        path: '/textbooksolution-:bookId/:directoryId(\\d+)-:bookName-:directoryName',
        name: 'textbook-answer',
        component: () => import('~/pages/textbook-answer/index.vue'),
        meta: {
          layout: 'textbook-answer',
        },
      },
      {
        path: '/textbooksolution-:bookId/:bookName',
        name: 'textbook-chapter-list',
        component: () => import('~/pages/textbook-chapter/index.vue'),
        meta: {
          layout: 'sidebar',
        },
      },
      {
        path: '/tbl/:subject/:page',
        component: () => import('~/pages/textbook-list/index.vue'),
      },
      // {
      //   path: '/tbs',
      //   component: () => import('~/pages/textbook-list/list.vue'),
      // },
      {
        path: '/tbd/:bookId/:directoryId?',
        component: () => import('~/pages/textbook-answer/index.vue'),
        meta: {
          layout: 'textbook-answer',
        },
      },
    ];
  },
};
